// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"32dd9eb9","453":"c3995a2f","667":"43e3e11b","977":"c987999f"}[chunkId] + ".chunk.js";
};